module.exports = __webpack_public_path__ + "f572638f/img/cadBim.e369a02a.png";